export const TEACHER = "teacher";
export const STUDENT = "student";
export const ADMIN = "admin";
export const ASSOCIATE_ADMIN = "associate_admin";

export const selectUserRoles = [
  {
    value: ADMIN,
    label: "Admin",
  },
  {
    value: ASSOCIATE_ADMIN,
    label: "Associate Admin",
  },
  // {
  //   value: STUDENT,
  //   label: "Student",
  // },
  // {
  //   value: TEACHER,
  //   label: "Teacher",
  // },
];

export const levelUserRoles = [
  {
    value: ADMIN,
    level: 4,
  },
  {
    value: ASSOCIATE_ADMIN,
    level: 3,
  },
  {
    value: STUDENT,
    level: 1,
  },
  {
    value: TEACHER,
    level: 2,
  },
];

export const roleToRouteMap = {
  elsaAdmin: 'admin',
  generalAdmin: 'dashboard',
  organizationAdmin: 'organization_setup',
  organizationAssociateAdmin: 'organization_setup',
  organizationTeacher: 'organizationteam',
  organizationSAStudent: 'comming-soon',
};
